import PropTypes from 'prop-types';
import React from 'react';
import StimulusButton from '../stimulus/StimulusButton';
import Illustration from '../illustration/Illustration';

const getStyles = ({ isDisabled, isSelected }, btnType) => {
    const statusStyle = isDisabled ? 'disabled-button' : '';
    const selectedStyle = isSelected ? 'selected' : '';
    const buttonStyle = `${btnType} ${statusStyle} ${selectedStyle}`;
    return buttonStyle.trim();
};

const ImageAudioAnswer = (props) => (
    <div className="comprehension-answer">
        <div className={getStyles(props, 'speaker-button')} onClick={props.onStimulusClick}>
            <StimulusButton isDisabled={props.isDisabled} isPlaying={props.isStimulusSelected} />
        </div>
        <div className={getStyles(props, 'answer-button')} onClick={props.onAnswerClick}>
            <Illustration altText="image" url={props.image} class="image-button" />
        </div>
    </div>
);

ImageAudioAnswer.propTypes = {
    image: PropTypes.string.isRequired,
    /* eslint-disable react/no-unused-prop-types */
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    /* eslint-disable react/no-unused-prop-types */
    isStimulusSelected: PropTypes.bool,
    onAnswerClick: PropTypes.func,
    onStimulusClick: PropTypes.func,
};

ImageAudioAnswer.defaultProps = {
    isSelected: false,
    isStimulusSelected: false,
    isDisabled: false,
    onAnswerClick: () => {},
    onStimulusClick: () => {},
};

export default ImageAudioAnswer;
